import { Component, forwardRef } from '@angular/core';
import { ModelService } from '../../../../Services/model.service';
import { StartAction } from '../../../../Model/Dto/StartAction';
import { UserActionBaseComponent } from '../userAction-base.component';
import { TranslateService } from '@ngx-translate/core';
import { CatalogService } from 'app/Services/CatalogManagement/catalog.service';
import { MacroService } from 'app/Services/CatalogManagement/macro.service';
import { JobService } from 'app/Services/job.service';
import { LoginService } from 'app/Services/login.service';
import { ProductReportingService } from 'app/Services/productreporting.service';
import { SystemService } from 'app/Services/system.service';
import { Macro } from 'app/Model/ui/Macro';

@Component({
  selector: 'userAction-exportReportProductDatasheet',
  templateUrl: 'userAction-exportReportProductDatasheet.component.html',
  providers: [
    { provide: UserActionBaseComponent, useExisting: forwardRef(() => UserActionExportReportProductDatasheet) }
  ]})
export class UserActionExportReportProductDatasheet extends UserActionBaseComponent {
  _allReports: string[];
  _selectedReport: string;
  _filenamePattern: string;
  _mimeDescr: string;
  _replaceAll: boolean = false;

  txtSelectReport: string;
  txtSelectFilenamePattern: string;

  constructor(
    public loginService: LoginService,
    public macroService: MacroService,
    public jobService: JobService,
    public translate: TranslateService,
    public catalogService: CatalogService,
    public productReportingService : ProductReportingService,
    public systemService : SystemService
  ) {
    super(loginService, macroService);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.txtSelectReport = this.translate.instant('Bitte wählen Sie einen Report aus');
    this.txtSelectFilenamePattern = this.translate.instant(
      'Bitte wählen Sie ein Muster für die Vergabe der Dateinamen aus'
    );

    this.productReportingService.getUrls().subscribe((items: string[]) => {
      this.allReports = items;
    });
  }

  get allReports(): string[] {
    return this._allReports;
  }

  set allReports(value: string[]) {
    this._allReports = value;
  }

  get selectedReport(): string {
    return this._selectedReport;
  }

  set selectedReport(value: string) {
    this._selectedReport = value;
  }

  get filenamePattern(): string {
    return this._filenamePattern;
  }

  set filenamePattern(value: string) {
    this._filenamePattern = value;
  }

  get mimeDescr(): string {
    return this._mimeDescr;
  }

  set mimeDescr(value: string) {
    this._mimeDescr = value;
  }

  get replaceAll(): boolean {
    return this._replaceAll;
  }

  set replaceAll(value: boolean) {
    this._replaceAll = value;
  }

  public async canStartMacro() : Promise<boolean>{
    if (this.selectedReport == '' || this.selectedReport == undefined) {
      this.systemService.notifyInfo(this.txtSelectReport);
      return false;
    }
    if (this.filenamePattern == '' || this.filenamePattern == undefined) {
      this.systemService.notifyInfo(this.txtSelectFilenamePattern);
      return false;
    }

    return true
  }

  public getActionId(macro: Macro): string {
    return `ExportReportProductDatasheet(${this.selectedReport}:${this.filenamePattern}:${this.replaceAll}:${this.mimeDescr})`;
  }

  public createParameterStringAsJsonString(): string {
    return JSON.stringify({selectedReport : this.selectedReport, filenamePattern: this. filenamePattern, replaceAll: this.replaceAll, mimeDescr: this.mimeDescr});
  }
  public parseParameter(parameter: string) {
    throw new Error('Method not implemented.');
  }
}
